import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo";
import InfiniteScroll from "react-infinite-scroll-component";
import { POSTS_FOR_ADMIN_QUERY } from "../../apollo/query";
import PostList from "../../components/BroadcastPostsList";
import Placeholder from "../../components/PlaceHolder";
import GlobalController from "../../utils/GlobalController";
import TitleHeader from "../../components/TitleHeader";
import SearchBar from "../../components/SearchBar";

const BroadcastPage = (props) => {
  const page = 1;
  const limit = 30;
  const { search } = props.history.location;
  const { start, end, mysearch } = GlobalController.queryResolver(search);

  const filter = {
    from: start,
    to: end,
    verified: true,
    enable: true,
  };

  const { loading, error, data, fetchMore } = useQuery(POSTS_FOR_ADMIN_QUERY, {
    variables: { page, limit, filter, search: mysearch },
    fetchPolicy: "cache-and-network",
  });

  if (loading && data === undefined) {
    return (
      <Dimmer active>
        <Loader />
      </Dimmer>
    );
  }

  if (error) return <p>{`Error Occurred: ${error.message}`}</p>;

  const count = data?.postsForAdmin?.count || 0;
  const postsForAdmin = data?.postsForAdmin?.payload || [];
  return (
    <div>
      <TitleHeader title="Live Broadcast" count={data.postsForAdmin.count} />
      <SearchBar
        isSearch={true}
        searching={mysearch.length > 0}
        goBack={() => props.history.goBack()}
      />
      <InfiniteScroll
        dataLength={postsForAdmin.length}
        next={() => {
          fetchMore({
            variables: {
              page: parseInt(postsForAdmin.length / limit) + 1,
              limit,
              ...filter,
              search: mysearch,
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev;
              console.log(fetchMoreResult.postsForAdmin.payload);
              const payload = [
                ...prev.postsForAdmin.payload,
                ...fetchMoreResult.postsForAdmin.payload,
              ];
              const postsForAdmin = {
                ...fetchMoreResult.postsForAdmin,
                payload: payload,
              };
              console.log(postsForAdmin);
              return Object.assign({}, prev, {
                postsForAdmin,
              });
            },
          });
        }}
        scrollThreshold={0.5}
        scrollableTarget="scrollingPoint"
        hasMore={count > postsForAdmin.length}
        loader={<Placeholder />}
      >
        <PostList posts={postsForAdmin} lightBlue="#fff" />
      </InfiniteScroll>
    </div>
  );
};

export default withRouter(BroadcastPage);
